import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { appRoutes, router } from '@/router';
import { AskDinkRoutesContext } from '@/features/ask-dink/askDinkRoutesContext';
import { AdminThemeProvider } from '@/theme';
import { BootstrapGate } from '@/config/BootstrapGate';
// Self-hosted fonts (Instrument Sans / JetBrains Mono / Material Symbols Outlined).
import '@/theme/fonts';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    {/* AdminThemeProvider (mode context → mode-aware theme → CssBaseline)
        wraps the whole tree — both the public auth routes and the gated app
        shell render under the theme (DNKADM-0266). BootstrapGate resolves the
        platform bootstrap (login/auth/brand/asset/pay origins, DNKADM-0274)
        before the router renders at all, so no branded chrome paints and no
        redirect decision (e.g. AuthGate's centralized-login redirect) is made
        before those origins are known. */}
    <AdminThemeProvider>
      <BootstrapGate>
        {/* The route tree the Ask Dink panel builds its screen list from (DNKADM-0434). */}
        <AskDinkRoutesContext.Provider value={appRoutes}>
          <RouterProvider router={router} />
        </AskDinkRoutesContext.Provider>
      </BootstrapGate>
    </AdminThemeProvider>
  </StrictMode>,
);
